import axios from 'axios';
import { getApiUrl } from '../../../config';

export const getFixedPricePayments = () => axios.request({
    method: 'GET',
    url: `${getApiUrl()}/billing/fixed-price-payments`,
    withCredentials: true,
    crossorigin: true
});

export const updateFixedPricePayment = (parentType, parentId, paymentId, body) => axios.request({
    method: 'PUT',
    url: `${getApiUrl()}/billing/fixed-price-payments/${parentType}/${parentId}/${paymentId}`,
    data: body,
    withCredentials: true,
    crossorigin: true
});

export const deleteFixedPricePayment = (parentType, parentId, paymentId) => axios.request({
    method: 'DELETE',
    url: `${getApiUrl()}/billing/fixed-price-payments/${parentType}/${parentId}/${paymentId}`,
    withCredentials: true,
    crossorigin: true
});

export const clearFixedPricePayments = (parentType, parentId) => axios.request({
    method: 'DELETE',
    url: `${getApiUrl()}/billing/fixed-price-payments/${parentType}/${parentId}`,
    withCredentials: true,
    crossorigin: true
});

export const getUnconfiguredFixedPriceEntities = () => axios.request({
    method: 'GET',
    url: `${getApiUrl()}/billing/fixed-price-payments/unconfigured`,
    withCredentials: true,
    crossorigin: true
});
